// extracted by mini-css-extract-plugin
module.exports = {"div":"Addticket_div__kr-d3","p":"Addticket_p__l3mTY","Card":"Addticket_Card__3cFd3","background":"Addticket_background__2Wt3a","link":"Addticket_link__26Ngm"};